import { ProfileItem } from '~/entities/ProfileItem/ProfileItem';
import { Button } from '~/shared/ui/Button/Button';
// import Plus from '/public/icons/plus.svg?react';
import {
  cvaProfileAltItem,
  cvaProfileItemsList,
} from '~/pages/ProfilePage/ui/ProfileItemsList/ProfileItemsListStyles';
// import { cvaIcon } from '~/shared/styles/IconStyles';
import { AddingAuto } from '~/features/AddingAuto/AddingAuto';
import { useLogout } from '~/shared/hooks/useLogout';
// import { useGetLk } from '~/shared/hooks/useGetLk';

export const ProfileItemsList = () => {
  // const { data } = useGetLk();
  const { logout, isLoading } = useLogout();

  return (
    <div className={cvaProfileItemsList()}>
      <div className={cvaProfileAltItem()}>
        <ProfileItem to={'/profile/cars'} title={'Мои Автомобили'} />
        <AddingAuto />
        {/* <Button
          href={'/add-place'}
          variant={'primary'}
          size={'common'}
          icon={<Plus className={cvaIcon({ iconSize: 'common' })} />}
          onlyIcon></Button> */}
      </div>
      {/* <ProfileItem
        to={'profit'}
        title={'Доход'}
        profit={data?.payload?.income ?? 0}
        alternative
      /> */}
      {/* <ProfileItem
        to={'notifications'}
        title={'Уведомления'}
        counter={data?.payload?.notification_unread_count}
      /> */}
      <ProfileItem to={'/profile/cards'} title={'Способы оплаты'} />
      <ProfileItem to={'/profile/booking'} title={'Мои Сессии'} />
      <ProfileItem to={'/profile/service'} title={'О компании'} />
      {/* <ProfileItem to={'referral'} title={'Реферальная программа '} />
      <ProfileItem to={'administration'} title={'Администратор парковки'} /> */}
      <Button
        variant={'red'}
        size={'tabs'}
        onClick={() => logout()}
        isLoading={isLoading}>
        Выйти из профиля
      </Button>
    </div>
  );
};
